import { SignIn } from '@clerk/clerk-react'
import { useSearchParams } from 'react-router-dom'

import { AuthLayout } from '@/components/auth/AuthLayout'
import { peekAuthRedirect, safeRedirect, withRedirect } from '@/lib/redirect'

export function SignInPage() {
  const [params] = useSearchParams()
  const fromParam = safeRedirect(params.get('redirect_url'))
  const target = fromParam === '/' ? (peekAuthRedirect() ?? '/') : fromParam

  return (
    <AuthLayout title="Welcome back">
      <SignIn
        path="/sign-in"
        routing="path"
        signUpUrl={withRedirect('/sign-up', target)}
        fallbackRedirectUrl={target}
        forceRedirectUrl={target}
      />
    </AuthLayout>
  )
}
